<app-navbar-style-two></app-navbar-style-two>

<!-- PAGE TITLE -->
<!-- <div class="page-title-area" *ngFor="let Content of pageTitle;">
    <div class="page-overlay"></div>

    <div class="container position-relative">
        <h1>{{Content.title}}</h1>
        <p>
            Welcome back! Login or create your account to continue.
        </p>
    </div>
</div> -->

<!-- AUTH SECTION -->
<div class="p-4 bg-dark"  style="margin-top: -90px;"></div>
<section class="profile-authentication-area ptb-100">

    <div class="container">

        <div class="auth-wrapper">

            <!-- LEFT SIDE -->
            <div class="auth-left">

                <div class="auth-content">

                    <span class="welcome-badge">
                        Welcome To
                    </span>

                    <h2 style="color:#ff6b35">
                        Kitchen Magic
                    </h2>

                    <p>
                        Experience authentic flavors with seamless ordering,
                        fast delivery and delicious meals prepared with love.
                    </p>

                    <ul class="auth-features">

                        <li>
                            <i class='bx bx-check-circle'></i>
                            Easy online ordering
                        </li>

                        <li>
                            <i class='bx bx-check-circle'></i>
                            Fresh & hygienic food
                        </li>

                      
                    </ul>

                </div>

            </div>

            <!-- RIGHT SIDE -->
            <div class="auth-right">

                <!-- TABS -->
                <!-- <div class="auth-tabs">

                    <button type="button" [class.active]="activeTab === 'login'" (click)="activeTab = 'login'">

                        Login

                    </button>

                    <button type="button" [class.active]="activeTab === 'register'" (click)="activeTab = 'register'">

                        Register

                    </button>

                </div> -->

                <!-- <div class="auth-tabs">

                  
                    <button *ngIf="activeTab === 'register'" type="button" class="active" (click)="activeTab = 'login'">

                        Login

                    </button>

                  
                    <button *ngIf="activeTab === 'login'" type="button" class="active" (click)="activeTab = 'register'">

                        Register

                    </button>

                </div> -->

                <!-- LOGIN FORM -->
                <div class="auth-form" *ngIf="activeTab === 'login'">

                    <h2>
                        Welcome Back 
                    </h2>

                    <p class="auth-subtitle">
                        Login to continue your delicious journey.
                    </p>

                    <form [formGroup]="loginForm" (ngSubmit)="login()">

                        <!-- USERNAME -->
                        <div class="form-group">

                            <label>
                                Username or Email
                            </label>

                            <input type="text" class="form-control" formControlName="username"
                                placeholder="Enter username or email">

                            <!-- VALIDATION -->
                            <div class="validation-error"
                                *ngIf="loginForm.get('username')?.touched && loginForm.get('username')?.invalid">

                                <small *ngIf="loginForm.get('username')?.errors?.['required']">
                                    Username is required.
                                </small>

                                <small *ngIf="loginForm.get('username')?.errors?.['minlength']">
                                    Minimum 3 characters required.
                                </small>

                            </div>

                        </div>

                        <!-- PASSWORD -->
                        <div class="form-group">

                            <label>
                                Password
                            </label>

                            <div class="password-input-wrapper">
                                <input [type]="showPassword ? 'text' : 'password'" class="form-control" formControlName="password"
                                    placeholder="Enter password">
                                <button type="button" class="password-toggle-btn" (click)="togglePasswordVisibility()">
                                    <i class="bx" [class.bx-show]="!showPassword" [class.bx-hide]="showPassword"></i>
                                </button>
                            </div>

                            <!-- VALIDATION -->
                            <div class="validation-error"
                                *ngIf="loginForm.get('password')?.touched && loginForm.get('password')?.invalid">

                                <small *ngIf="loginForm.get('password')?.errors?.['required']">
                                    Password is required.
                                </small>

                                <small *ngIf="loginForm.get('password')?.errors?.['minlength']">
                                    Minimum 6 characters required.
                                </small>

                            </div>

                        </div>

                        <!-- EXTRA -->
                        <div class="auth-extra">

                            <div class="remember-me-wrap">

                                <label class="custom-checkbox">

                                    <input type="checkbox">

                                    <span class="checkmark"></span>

                                    Remember me

                                </label>

                            </div>

                            <div class="lost-your-password-wrap">

                                <a (click)="activeTab = 'forgot'" class="lost-your-password">

                                    Forgot Password?

                                </a>

                            </div>

                        </div>

                        <!-- BUTTON -->
                        <button type="submit" class="auth-btn" [disabled]="loginForm.invalid">

                            Login Now

                        </button>
                        <!-- SWITCH TO REGISTER -->
                        <div class="switch-auth-text">

                            <span>
                                Not a user?
                            </span>

                            <a href="javascript:void(0)" (click)="activeTab = 'register'">
                                Sign Up
                            </a>

                        </div>

                    </form>

                </div>

                <!-- FORGOT PASSWORD FORM -->
                <div class="auth-form" *ngIf="activeTab === 'forgot'">

                    <h2>
                        Forgot Password
                    </h2>

                    <p class="auth-subtitle">
                        Enter your email to reset your password.
                    </p>

                    <form [formGroup]="forgotPasswordForm" (ngSubmit)="forgotPassword()">

                        <!-- EMAIL -->
                        <div class="form-group">

                            <label>
                                Email Address
                            </label>

                            <input type="email" class="form-control" formControlName="email"
                                placeholder="Enter your email">

                            <!-- VALIDATION -->
                            <div class="validation-error"
                                *ngIf="forgotPasswordForm.get('email')?.touched && forgotPasswordForm.get('email')?.invalid">

                                <small *ngIf="forgotPasswordForm.get('email')?.errors?.['required']">
                                    Email is required.
                                </small>

                                <small *ngIf="forgotPasswordForm.get('email')?.errors?.['email']">
                                    Please enter a valid email.
                                </small>

                            </div>

                        </div>

                        <!-- BUTTON -->
                        <button type="submit" class="auth-btn" [disabled]="forgotPasswordForm.invalid">

                            Reset Password

                        </button>

                        <!-- BACK TO LOGIN -->
                        <div class="switch-auth-text">

                            <a href="javascript:void(0)" (click)="activeTab = 'login'">
                                Back to Login
                            </a>

                        </div>

                    </form>

                </div>

                <!-- REGISTER FORM -->
                <div class="auth-form" *ngIf="activeTab === 'register'">

                    <h2>
                        Create Account 
                    </h2>

                    <p class="auth-subtitle">
                        Register now and enjoy amazing food ordering experience.
                    </p>

                    <form [formGroup]="registerForm" (ngSubmit)="register()">

                        <!-- USERNAME -->
                        <div class="form-group">

                            <label>
                                Username
                            </label>

                            <input type="text" class="form-control" formControlName="username"
                                placeholder="Enter username">

                            <!-- VALIDATION -->
                            <div class="validation-error"
                                *ngIf="registerForm.get('username')?.touched && registerForm.get('username')?.invalid">

                                <small *ngIf="registerForm.get('username')?.errors?.['required']">
                                    Username is required.
                                </small>

                                <small *ngIf="registerForm.get('username')?.errors?.['minlength']">
                                    Minimum 3 characters required.
                                </small>

                            </div>

                        </div>

                        <!-- MOBILE -->
                        <div class="form-group">

                            <label>
                                Mobile Number
                            </label>

                            <input type="text" class="form-control" formControlName="mobile"
                                placeholder="Enter  mobile number">

                            <!-- VALIDATION -->
                            <div class="validation-error"
                                *ngIf="registerForm.get('mobile')?.touched && registerForm.get('mobile')?.invalid">

                                <small *ngIf="registerForm.get('mobile')?.errors?.['required']">
                                    Mobile number is required.
                                </small>

                                <!-- <small *ngIf="registerForm.get('mobile')?.errors?.['pattern']">
                                    Enter a valid 10 digit mobile number.
                                </small> -->

                            </div>

                        </div>

                        <!-- EMAIL -->
                        <div class="form-group">

                            <label>
                                Email
                            </label>

                            <input type="email" class="form-control" formControlName="email" placeholder="Enter email">

                            <!-- VALIDATION -->
                            <div class="validation-error"
                                *ngIf="registerForm.get('email')?.touched && registerForm.get('email')?.invalid">

                                <small *ngIf="registerForm.get('email')?.errors?.['required']">
                                    Email is required.
                                </small>

                                <small *ngIf="registerForm.get('email')?.errors?.['email']">
                                    Enter a valid email address.
                                </small>

                            </div>

                        </div>

                        <!-- PASSWORD -->
                        <div class="form-group">

                            <label>
                                Password
                            </label>

                            <div class="password-input-wrapper">
                                <input [type]="showRegisterPassword ? 'text' : 'password'" class="form-control" formControlName="password"
                                    placeholder="Enter password">
                                <button type="button" class="password-toggle-btn" (click)="toggleRegisterPasswordVisibility()">
                                    <i class="bx" [class.bx-show]="!showRegisterPassword" [class.bx-hide]="showRegisterPassword"></i>
                                </button>
                            </div>

                            <!-- VALIDATION -->
                            <div class="validation-error"
                                *ngIf="registerForm.get('password')?.touched && registerForm.get('password')?.invalid">

                                <small *ngIf="registerForm.get('password')?.errors?.['required']">
                                    Password is required.
                                </small>

                                <small *ngIf="registerForm.get('password')?.errors?.['minlength']">
                                    Minimum 8 characters required.
                                </small>

                                <small *ngIf="registerForm.get('password')?.errors?.['pattern']">
                                    Must include uppercase, lowercase, number, and special character.
                                </small>

                            </div>

                        </div>

                        <!-- CONFIRM -->
                        <div class="form-group">

                            <label>
                                Confirm Password
                            </label>

                            <div class="password-input-wrapper">
                                <input [type]="showConfirmPassword ? 'text' : 'password'" class="form-control" formControlName="confirmPassword"
                                    placeholder="Confirm password">
                                <button type="button" class="password-toggle-btn" (click)="toggleConfirmPasswordVisibility()">
                                    <i class="bx" [class.bx-show]="!showConfirmPassword" [class.bx-hide]="showConfirmPassword"></i>
                                </button>
                            </div>

                            <!-- VALIDATION -->
                            <div class="validation-error"
                                *ngIf="registerForm.touched && registerForm.errors?.['passwordMismatch']">

                                <small>
                                    Passwords do not match.
                                </small>

                            </div>

                        </div>

                        <!-- DESCRIPTION -->
                        <p class="description">

                            The password should be at least eight characters long.
                            To make it stronger, use upper and lower case letters,
                            numbers, and symbols.

                        </p>

                        <!-- BUTTON -->
                        <button type="submit" class="auth-btn" [disabled]="registerForm.invalid">

                            Create Account

                        </button>

                        <!-- SWITCH TO LOGIN -->
                        <div class="switch-auth-text">

                            <span>
                                Already have an account?
                            </span>

                            <a href="javascript:void(0)" (click)="activeTab = 'login'">
                                Sign In
                            </a>

                        </div>

                    </form>

                </div>

            </div>

        </div>

    </div>

</section>